import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Icon } from "@iconify/react";
import BaseDialog from "./BaseDialog";
import CommonButton from "./CommonButton";
import { c } from "@/theme/colorUtils";

const OptionList = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  width: "100%"
}));

const FILE_TYPES = [
  { value: "jpeg", label: "JPG", icon: "famicons:image-outline" },
  { value: "png", label: "PNG", icon: "cil:vector" },
  { value: "pdf", label: "PDF", icon: "streamline-flex:pdf-reader-application" },
];

function ShareFileTypeDialog({ open, onClose, onExport, intl, showPdf = true }) {
  const [selectedType, setSelectedType] = useState(null);

  useEffect(() => {
    if (open) {
      setSelectedType(null);
    }
  }, [open]);

  const handleExport = () => {
    if (!selectedType) return;
    const type = selectedType;
    if (onClose) onClose();
    if (onExport) {
      Promise.resolve(onExport(type)).catch((err) =>
        console.error("ShareFileTypeDialog onExport:", err)
      );
    }
  };

  const options = showPdf ? FILE_TYPES : FILE_TYPES.filter((f) => f.value !== "pdf");

  return (
    <BaseDialog
      type="drawer"
      open={open}
      onClose={onClose}
      title={intl.formatMessage({ id: "share_type" })} /* 공유할 파일 유형 선택 */
      content={intl.formatMessage({ id: "share_type_select" })} /* 파일로 내보내기 및 공유할\n리포트의 유형을 선택해주세요. */  
      actionType="single"
      singleButtonText={intl.formatMessage({ id: "share_export" })} /* 내보내기 */
      singleButtonDisabled={!selectedType}
      onSingleClick={handleExport}
      anchor="bottom"
    >
      <OptionList>
        {options.map(({ value, label, icon }) => (
          <CommonButton
            key={value}
            border={selectedType === value ? c.primary : c.grayHard}
            background={selectedType === value ? c.bg02 : c.bg}
            color={c.text01}
            text={label}
            icon={<Icon icon={icon} width={24} height={24} />}
            iconPosition="left"
            onClick={() => setSelectedType((prev) => (prev === value ? null : value))}
          />
        ))}
      </OptionList>
    </BaseDialog>
  );
}

ShareFileTypeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  /** (fileType: 'jpeg' | 'png' | 'pdf') => void | Promise<void> — 다이얼로그는 먼저 닫힌 뒤 호출됩니다. */
  onExport: PropTypes.func,
  intl: PropTypes.object.isRequired,
  showPdf: PropTypes.bool,
};

ShareFileTypeDialog.defaultProps = {
  onExport: undefined,
  showPdf: true,
};

export default injectIntl(ShareFileTypeDialog);
